import { API } from '../api';
import axiosInstance from '../axiosConfig';

export const getPaymentHistory = async (id) => {
  const response = await axiosInstance.get(API.PAYEMNT_TRANSACTIONS.GET_ALL_PAYMENTS + id);
  return response;
};

export const getSerilizedPaymentHistory = async (locationId, page, perPage, startDate, endDate) => {
  const response = await axiosInstance.get(
    `${API.PAYEMNT_TRANSACTIONS.PAGINATION_PAYEMNTS}?locationId=${locationId}&page=${page}&perPage=${perPage}&startDate=${startDate}&endDate=${endDate}`
  );
  return response;
};

export const getSerilizedPaymentHistorySearch = async (body) => {
  const response = await axiosInstance.post(
    `${API.PAYEMNT_TRANSACTIONS.PAYMENT_HISTORY_SEARCH}`,
    body
  );
  return response;
};

export const getSerilizedPaymentLogs = async (locationId, page, perPage, startDate, endDate) => {
  const url = `${API.PAYEMNT_TRANSACTIONS.PAGINATION_LOGS}?locationId=${locationId}&page=${page}&perPage=${perPage}&startDate=${startDate}&endDate=${endDate}`;

  const response = await axiosInstance.get(url);
  console.log(response);
  return response;
};

export const getSerilizedPaymentSearch = async (body) => {
  const response = await axiosInstance.post(
    `${API.PAYEMNT_TRANSACTIONS.PAGINATION_PAYMENT_LOG_SEARCH}`,
    body
  );
  return response;
};

//report Complete Payment Log
export const getSerilizedCompletePaymentLogs = async (page, perPage, startDate, endDate) => {
  const url = `${API.PAYEMNT_TRANSACTIONS.ALL_PAGINATION_LOGS}?page=${page}&perPage=${perPage}&startDate=${startDate}&endDate=${endDate}`;
  const response = await axiosInstance.get(url);
  console.log(response);
  return response;
};

export const getSerilizedCompletePaymentSearch = async (body) => {
  const response = await axiosInstance.post(
    `${API.PAYEMNT_TRANSACTIONS.PAGINATION_PAYMENT_LOG_SEARCH}`,
    body
  );
  return response;
};
